import { useCallback } from 'react';
import { IStation } from 'dataSources/Typicode/stations/types';
import usePermissions from 'common/hooks/usePermissions';
import { useOperations as useStationOperations } from 'store/features/station';
import {
  addURLParamActiveStation,
  deleteURLParamActiveStation,
  deleteURLParamBoundCountries
} from 'entities/application';

import useHandlerShowStationModal from '../hooks/useHandlerShowStationModal';

const useMarkerClick = () => {
  const handlerShowStationModal = useHandlerShowStationModal();
  const permissions = usePermissions();
  const { updateSelectedStation } = useStationOperations();

  const onMarkerClick = useCallback((data: IStation) => {
    if (permissions.servicePointView && data && data.code) {      
      handlerShowStationModal({ ...data, isClicked: true });
      updateSelectedStation(data.code);
      deleteURLParamActiveStation();
      deleteURLParamBoundCountries();
      addURLParamActiveStation(data.code);
    }
  }, [ permissions, handlerShowStationModal, updateSelectedStation ]);

  return onMarkerClick;
};

export default useMarkerClick;
